import { PageType } from "shared/lib/page-type";

export const pathname = "/games/word-search/[date]";

export type RouteParameters = {
  date: string;
};

export const page = {
  pathname,
  route(query: { date: string }) {
    const { date } = query;

    return {
      pathname: `/games/word-search/${date}`,
      query: {
        date,
        pageType: PageType.GamesWordSearch,
      },
    };
  },
};
